import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router';
import { Col, Form, Button, FormGroup, Input, Label, Row, Alert } from 'reactstrap';
import { useMediaQuery } from 'react-responsive';

import Loader from '../../Common/Loader';
import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';
import SpotifyButton from '../../Buttons/SpotifyButton/SpotifyButton';

import { ReactComponent as PlusIcon } from '../../../assets/images/plus.svg';
import { ReactComponent as RemoveIcon } from '../../../assets/images/remove.svg';

import { loadUser, editUser, editUserImage, editUserSpotify } from '../../../helpers/api/users.api';

import '../Forms.scss';

const ArtistsContentsForm = (props) => {
	const MOBILE_AND_TABLET = useMediaQuery({
		query: '(max-device-width: 768px)',
	});

	let imagePicker = useRef(null);
	let picsPicker = useRef(null);

	const [user, setUser] = useState(null);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);

	const [loadingImage, setLoadingImage] = useState(false);

	const [loadingSpotify, setLoadingSpotify] = useState(false);

	useEffect(() => {
		if (localStorage.getItem('authUser')) {
			setLoading(true);
			const userId = JSON.parse(localStorage.getItem('authUser'))._id;
			loadUser(userId)
				.then((result) => {
					if (result.success) setUser(result.user);
					else console.log(result.message);
					setLoading(false);
				})
				.catch((error) => {
					setLoading(false);
					console.log(error);
				});
		}
	}, []);

	useEffect(() => {
		const urlParams = new URLSearchParams(props.location.search);
		if (urlParams.get('requested') === 'spotify' && urlParams.get('code')) {
		}
	}, [props.location.search]);

	function handleOnImageClick() {
		if (imagePicker.current && imagePicker.current.click) imagePicker.current.click();
	}

	function handleOnImageSubmit({ target: { files } }) {
		if (files && files.length > 0) {
			let image = files[0];
			if (!image.type.startsWith('image')) window.alert('Devi caricare un file immagine.');
			else {
				setLoadingImage(true);
				editUserImage(image)
					.then((result) => {
						if (result.success) setUser(result.updated);
						else setError(result.message);
						setLoadingImage(false);
					})
					.catch((error) => {
						setError(error.message);
						setLoadingImage(false);
					});
			}
		}
	}

	function handleOnRemovePicClick(index) {
		let editedUser = { ...user };
		if (editedUser.pics && editedUser.pics.length > 0) {
			editedUser.pics.splice(index, 1);
			setUser(editedUser);
		}
	}

	function handleOnPicsClick() {
		if (picsPicker.current && picsPicker.current.click) picsPicker.current.click();
	}

	function handleOnPicSubmit({ target: { files } }) {
		if (files && files.length > 0) {
			let pic = files[0];
			if (!pic.type.startsWith('image')) window.alert('Devi caricare un file immagine.');
			else {
				pic.preview = URL.createObjectURL(pic);
				let editedUser = { ...user };
				editedUser.pics ? editedUser.pics.push(pic) : (editedUser.pics = [pic]);
				setUser(editedUser);
			}
		}
	}

	function handleOnFieldChange({ target: { name, value } }) {
		let editedUser = { ...user };

		if (['facebook', 'twitter', 'website', 'instagram', 'tiktok', 'youtube'].includes(name))
			editedUser.socialLinks[name] = value;
		else editedUser[name] = value;
		setUser(editedUser);
	}

	function handleOnAddAward() {
		let editedUser = { ...user };
		if (!editedUser.awards || !Array.isArray(editedUser.awards)) editedUser.awards = [];
		editedUser.awards.push({ name: '', info: '' });
		setUser(editedUser);
	}

	function handleOnAwardFieldChange({ target: { name, value } }, index) {
		let editedUser = { ...user };
		editedUser['awards'][index][name] = value;
		setUser(editedUser);
	}

	function handleOnAddConcert() {
		let editedUser = { ...user };
		if (!editedUser.concerts || !Array.isArray(editedUser.concerts)) editedUser.concerts = [];
		editedUser.concerts.push({ name: '', location: '', date: '', info: '' });
		setUser(editedUser);
	}

	function handleOnConcertFieldChange({ target: { name, value } }, index) {
		let editedUser = { ...user };
		editedUser['concerts'][index][name] = value;
		setUser(editedUser);
	}

	function handleOnAddRelease() {
		let editedUser = { ...user };
		if (!editedUser.releases || !Array.isArray(editedUser.releases)) editedUser.releases = [];
		editedUser.releases.push({ title: '', type: 'album', year: '', nTracks: '' });
		setUser(editedUser);
	}

	function handleOnReleaseFieldChange({ target: { name, value, files } }, index) {
		if (files && files[0].size > 1000000) return;

		let editedUser = { ...user };
		editedUser['releases'][index][name] = value;
		setUser(editedUser);
	}

	async function handleOnSpotifySubmit() {
		setLoadingSpotify(true);
		editUserSpotify(user.spotifyId)
			.then((result) => {
				if (result.success) setUser(result.updated);
				else setError(result.message);
				setLoadingSpotify(false);
			})
			.catch((error) => {
				setLoadingSpotify(false);
				setError(error);
			});
	}

	function handleOnDataUpdateSubmit(event) {
		event.preventDefault();
		setLoading(true);
		editUser(user)
			.then((result) => {
				if (result.success) setUser(result.updated);
				else setError(result.message);
				setLoading(false);
			})
			.catch((error) => {
				setError(error.message);
				setLoading(false);
			});
	}

	return loading ? (
		<Loader />
	) : error ? (
		<Alert color="danger">{error}</Alert>
	) : user ? (
		<Form onSubmit={handleOnDataUpdateSubmit}>
			<FormGroup row>
				<Col md="4">
					<h6>Foto Profilo</h6>
					{loadingImage ? (
						<Loader />
					) : user.image ? (
						<div
							style={{
								backgroundImage: 'url(' + user.image.url + ')',
							}}
							className="avatar-xs rounded-circle profile-avatar"
						></div>
					) : null}

					<RoundedButton className="px-5 mt-4" color="primary" onClick={handleOnImageClick}>
						Carica
					</RoundedButton>
					<Input
						innerRef={imagePicker}
						type="file"
						style={{ display: 'none' }}
						onChange={handleOnImageSubmit}
					/>

					<h6>Informazioni</h6>

					<Label for="artistType">Tipologia</Label>
					<Input
						type="select"
						name="artistType"
						id="artistType"
						value={user.artistType}
						onChange={handleOnFieldChange}
					>
						<option selected={!user.artistType} value="">
							-
						</option>
						<option selected={user.artistType === 'solo'} value="solo">
							Solista
						</option>
						<option selected={user.artistType === 'band'} value="band">
							Band
						</option>
						<option selected={user.artistType === 'producer'} value="producer">
							Producer
						</option>
					</Input>

					<Label for="nMembers">N° componenti</Label>
					<Input
						type="number"
						disabled={user.artistType !== 'band'}
						name="nMembers"
						id="nMembers"
						value={user.nMembers}
						onChange={handleOnFieldChange}
					/>

					<Label for="city">Città</Label>
					<Input type="text" name="city" id="city" value={user.city} onChange={handleOnFieldChange} />
				</Col>
				<Col
					md={{
						size: 6,
						offset: 2,
					}}
				>
					<Row>
						<Col md="8">
							<h6 className="mt-3">Link Social</h6>
							<Label for="website">Sito Web</Label>
							<Input
								type="text"
								name="website"
								id="website"
								value={user.socialLinks.website}
								onChange={handleOnFieldChange}
							/>
							<Label for="facebook">Facebook</Label>
							<Input
								type="text"
								name="facebook"
								id="facebook"
								value={user.socialLinks.facebook}
								onChange={handleOnFieldChange}
							/>
							<Label for="instagram">Instagram</Label>
							<Input
								type="text"
								name="instagram"
								id="instagram"
								value={user.socialLinks.instagram}
								onChange={handleOnFieldChange}
							/>
							<Label for="tiktok">TikTok</Label>
							<Input
								type="text"
								name="tiktok"
								id="tiktok"
								value={user.socialLinks.tiktok}
								onChange={handleOnFieldChange}
							/>
							<Label for="youtube">YouTube</Label>
							<Input
								type="text"
								name="youtube"
								id="youtube"
								value={user.socialLinks.youtube}
								onChange={handleOnFieldChange}
							/>
						</Col>

						<Col md="12">
							<h6>Foto</h6>
							<div className="pics-scroller">
								{user.pics &&
									user.pics.map((p, i) => (
										<div className="artist-pic" key={'pic+' + i}>
											<Button
												color="link"
												className="remove-pic"
												onClick={() => handleOnRemovePicClick(i)}
											>
												<RemoveIcon />
											</Button>
											<img src={p.preview || p.url} alt="" />
										</div>
									))}

								{!user.pics || user.pics.length < 10 ? (
									<Button className="add-pic" color="link" onClick={handleOnPicsClick}>
										<PlusIcon />
										<Input
											innerRef={picsPicker}
											type="file"
											style={{
												display: 'none',
											}}
											onChange={handleOnPicSubmit}
										/>
									</Button>
								) : null}
							</div>
						</Col>

						<Col md="8">
							<h6>Video</h6>
							<Label for="twitter">Link YouTube embed</Label>
							<Input
								type="textarea"
								name="video"
								id="video"
								value={user.videoUrl}
								onChange={handleOnFieldChange}
							/>
						</Col>
					</Row>
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<Row>
						<Col className="d-flex align-items-center">
							<h6 className="d-inline">Album/EP/Singoli</h6>
							<Button className="add-release d-inline" color="link" onClick={handleOnAddRelease}>
								<PlusIcon />
							</Button>
							<p className="d-block d-lg-inline mx-auto mx-lg-3 pt-3 text-center">oppure</p>
							{loadingSpotify ? (
								<Loader />
							) : (
								<div>
									<Input
										name="spotifyId"
										type="text"
										className="form-control d-inline w-auto mb-0 mr-2"
										style={{ padding: '1.5em 1.5em' }}
										id="spotifyId"
										placeholder="Spotify Artist ID"
										value={user.spotifyId}
										onChange={handleOnFieldChange}
									/>
									<SpotifyButton className="mb-0" onClick={handleOnSpotifySubmit} />
								</div>
							)}
						</Col>
					</Row>
					<hr />
					{user.releases?.map((r, i) => (
						<React.Fragment key={'release-' + i}>
							<Row className="pt-3">
								<Col xs="8" lg="3">
									<Label for="type">Tipologia</Label>
									<Input
										type="select"
										name="type"
										id="type"
										value={r.type}
										onChange={(event) => handleOnReleaseFieldChange(event, i)}
									>
										<option selected={r.type === 'album'} value="album">
											Album
										</option>
										<option selected={r.type === 'single'} value="single">
											EP/Singolo
										</option>
									</Input>
								</Col>
								<Col xs="8" lg="3">
									<Label for="title">Titolo</Label>
									<Input
										type="text"
										name="title"
										id="title"
										value={r.title}
										onChange={(event) => handleOnReleaseFieldChange(event, i)}
									/>
								</Col>
								<Col xs="8" lg="3">
									<Label for="year">Anno</Label>
									<Input
										type="number"
										step={1}
										name="year"
										id="year"
										value={r.year}
										onChange={({ target: { name, value, files } }) => handleOnReleaseFieldChange({ target: { name, value: Number(value), files } }, i)}
									/>
								</Col>
								<Col xs="8" lg="3">
									<Label for="nTracks">N° di Tracce</Label>
									<Input
										type="number"
										step={1}
										name="nTracks"
										id="nTracks"
										value={r.nTracks}
										onChange={({ target: { name, value, files } }) => handleOnReleaseFieldChange({ target: { name, value: Number(value), files } }, i)}
									/>
								</Col>
							</Row>
							<Row className="pt-2 pb-3">
								<Col>
									<Label for="nTracks">Cover release (formato jpeg - dimensioni massime: 1mb)</Label>
									<Input
										name="cover"
										type="file"
										// style={{
										// 	display: 'none'
										// }}
										accept="image/jpeg"
										onChange={(event) => handleOnReleaseFieldChange(event, i)}
									/>
								</Col>
							</Row>
						</React.Fragment>
					))}
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<h6 className="d-inline">Storico Concerti</h6>
					<Button className="add-concert" color="link" onClick={handleOnAddConcert}>
						<PlusIcon />
					</Button>
					<hr />
					{user.concerts?.map((c, i) => (
						<Row className="py-3" key={'concert-' + i}>
							<Col xs="8" lg="3">
								<Label for="name">Evento</Label>
								<Input
									type="text"
									name="name"
									id="name"
									value={c.name}
									onChange={(event) => handleOnConcertFieldChange(event, i)}
								/>
							</Col>
							<Col xs="8" lg="3">
								<Label for="location">Luogo</Label>
								<Input
									type="text"
									name="location"
									id="location"
									value={c.location}
									onChange={(event) => handleOnConcertFieldChange(event, i)}
								/>
							</Col>
							<Col xs="8" lg="3">
								<Label for="date">Data</Label>
								<Input
									type="text"
									name="date"
									id="date"
									placeholder="gg/mm/aaaa"
									value={c.date}
									onChange={(event) => handleOnConcertFieldChange(event, i)}
								/>
							</Col>
							<Col xs="8" lg="3">
								<Label for="info">Informazioni</Label>
								<Input
									type="text"
									name="info"
									id="info"
									placeholder="Informazioni aggiuntive..."
									value={c.info}
									onChange={(event) => handleOnConcertFieldChange(event, i)}
								/>
							</Col>
						</Row>
					))}
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<h6 className="d-inline">Riconoscimenti</h6>
					<Button className="add-award" color="link" onClick={handleOnAddAward}>
						<PlusIcon />
					</Button>
					<hr />
					{user.awards?.map((a, i) => (
						<Row className="py-3" key={'award-' + i}>
							<Col xs="8" lg="4">
								<Label for="name">Nome</Label>
								<Input
									type="text"
									name="name"
									id="name"
									value={a.name}
									onChange={(event) => handleOnAwardFieldChange(event, i)}
								/>
							</Col>
							<Col xs="8" lg="4">
								<Label for="info">Informazioni</Label>
								<Input
									type="text"
									name="info"
									id="info"
									placeholder="Informazioni aggiuntive..."
									value={a.info}
									onChange={(event) => handleOnAwardFieldChange(event, i)}
								/>
							</Col>
						</Row>
					))}
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<h6>Label</h6>
					<hr />
					<Label for="label">Nome</Label>
					<Input
						type="text"
						name="label"
						id="label"
						className="w-25"
						value={user.label}
						onChange={handleOnFieldChange}
					/>
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<h6>Management</h6>
					<hr />
					<Label for="management">Nome</Label>
					<Input
						type="text"
						name="management"
						id="management"
						className="w-25"
						value={user.management}
						onChange={handleOnFieldChange}
					/>
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<h6>Collecting</h6>
					<hr />
					<Label for="collecting">
						Seleziona la società di collecting se presente (puoi selezionare più opzioni)
					</Label>
					<Input
						type="select"
						name="collecting"
						id="collecting"
						className="w-25"
						value={user.collecting}
						onChange={handleOnFieldChange}
					>
						<option selected={!user.collecting} value="">
							-
						</option>
						<option selected={user.artistType === 'siae'} value="siae">
							SIAE
						</option>
						<option selected={user.artistType === 'soundreef'} value="soundreef">
							Soundreef
						</option>
						<option selected={user.artistType === 'evolution'} value="evolution">
							Evolution srl
						</option>
					</Input>
				</Col>
			</FormGroup>
			<FormGroup row>
				<Col xs="12" lg="10">
					<RoundedButton className="d-block px-5 py-2 mt-4 mb-4 mx-auto" color="primary" type="submit">
						Salva Modifiche
					</RoundedButton>
				</Col>
			</FormGroup>
		</Form>
	) : null;
};

export default withRouter(ArtistsContentsForm);
